import React from "react";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Pie } from "react-chartjs-2";
import PropTypes from "prop-types";
import { FormatInt } from "../../../utils/FormatData";
import { PieChartSkeleton } from "../Skeleton/Chart";
ChartJS.register(ArcElement, Tooltip, Legend);

const PieChart = (props) => {
  const {
    title = "",
    labels = [],
    dataSets = [],
    label = "",
    loading,
    callbackLabel = "SMS",
  } = props;
  const data = {
    labels: labels,
    datasets: [
      {
        label: label,
        data: dataSets,
        backgroundColor: ["#3B82F6", "#10B981"],
        borderColor: ["#2563EB", "#16A34A"],
        borderWidth: 1,
      },
    ],
  };

  const options = {
    plugins: {
      tooltip: {
        backgroundColor: "#fff",
        borderColor: "#e5e7eb",
        width: 200,
        borderWidth: 1,
        borderRadius: 8,
        titleColor: "#000",
        bodyColor: "#000",
        callbacks: {
          label: (ctx) => {
            return `${callbackLabel}: ${FormatInt(ctx.parsed)}`;
          },
        },
      },
    },
  };

  if (loading) return <PieChartSkeleton />;

  if (dataSets.every((item) => item === 0)) {
    return (
      <div className="w-full h-full bg-white p-4 rounded-lg">
        <div className="flex flex-col items-center justify-center h-full space-y-2">
          <span className="material-symbols-outlined text-[50px] mb-1">
            pie_chart
          </span>
          <div className="text-gray-500 text-sm">
            No hay información disponible
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full h-full bg-white p-4 rounded-lg">
      <div className="text-md font-semibold mb-2">{title}</div>
      <Pie data={data} options={options} />
    </div>
  );
};

PieChart.propTypes = {
  title: PropTypes.string,
  loading: PropTypes.bool,
  labels: PropTypes.array,
  dataSets: PropTypes.array,
  label: PropTypes.string,
  callbackLabel: PropTypes.func,
};

export default PieChart;
